import { render, staticRenderFns } from "./recruitment-view-attachments.vue?vue&type=template&id=05f3e66f"
import script from "./recruitment-view-attachments.vue?vue&type=script&lang=js"
export * from "./recruitment-view-attachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports